var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2TableAvailableWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5002 48.3334L18.1252 39.2709C18.4877 38.3445 19.0717 37.6091 19.8772 37.0645C20.6828 36.5199 21.5891 36.2485 22.596 36.2501H26.5835V26.523C20.421 26.3216 15.255 25.4154 11.0854 23.8042C6.91586 22.1931 4.83189 20.3001 4.8335 18.1251C4.8335 15.789 7.18975 13.7952 11.9022 12.1438C16.6147 10.4924 22.3141 9.66675 29.0002 9.66675C35.7265 9.66675 41.4363 10.4924 46.1295 12.1438C50.8227 13.7952 53.1684 15.789 53.1668 18.1251C53.1668 20.3001 51.0821 22.1931 46.9125 23.8042C42.7429 25.4154 37.5777 26.3216 31.4168 26.523V36.2501H35.4043C36.371 36.2501 37.2676 36.5224 38.0941 37.0669C38.9206 37.6115 39.5143 38.3461 39.8752 39.2709L43.5002 48.3334H38.6668L35.7668 41.0834H22.2335L19.3335 48.3334H14.5002Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2TableAvailableWhite);
export default __webpack_public_path__ + "static/media/v2-table-available-white.0dd0c78e059f5af2e80f1949a3eb169b.svg";
export { ForwardRef as ReactComponent };